function cov_1852yfi5o6() {
  var path = "/app/src/utils/is-referring-finite-number.ts";
  var hash = "e13700ee45ea474f799e07fd086869fd8c4202ca";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/is-referring-finite-number.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 11,
          column: 3
        }
      },
      "1": {
        start: {
          line: 4,
          column: 6
        },
        end: {
          line: 4,
          column: 18
        }
      },
      "2": {
        start: {
          line: 6,
          column: 26
        },
        end: {
          line: 6,
          column: 61
        }
      },
      "3": {
        start: {
          line: 7,
          column: 6
        },
        end: {
          line: 7,
          column: 72
        }
      },
      "4": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "isReferringFiniteNumber",
        decl: {
          start: {
            line: 1,
            column: 16
          },
          end: {
            line: 1,
            column: 39
          }
        },
        loc: {
          start: {
            line: 1,
            column: 51
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 3,
            column: 4
          },
          end: {
            line: 4,
            column: 18
          }
        }, {
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 10,
            column: 19
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 7,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 7,
            column: 31
          }
        }, {
          start: {
            line: 7,
            column: 35
          },
          end: {
            line: 7,
            column: 71
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e13700ee45ea474f799e07fd086869fd8c4202ca"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1852yfi5o6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1852yfi5o6();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export function isReferringFiniteNumber(candidate) {
  cov_1852yfi5o6().f[0]++;
  cov_1852yfi5o6().s[0]++;
  switch (_typeof(candidate)) {
    case 'number':
      cov_1852yfi5o6().b[0][0]++;
      cov_1852yfi5o6().s[1]++;
      return true;
    case 'string':
      cov_1852yfi5o6().b[0][1]++;
      {
        var priceNumber = (cov_1852yfi5o6().s[2]++, candidate.replace(/,/g, '.').trim());
        cov_1852yfi5o6().s[3]++;
        return (cov_1852yfi5o6().b[1][0]++, priceNumber !== '') && (cov_1852yfi5o6().b[1][1]++, Number.isFinite(Number(priceNumber)));
      }
    default:
      cov_1852yfi5o6().b[0][2]++;
      cov_1852yfi5o6().s[4]++;
      return false;
  }
}